import api from './api';

export type EntityType =
  | 'VectorSystem'
  | 'FarmIT'
  | 'AutomaticMilkFilter'
  | 'AstronautA5Next'
  | 'Discovery'
  | 'NCapture'
  | 'AstronautMax'
  | 'Juno';

export type EntityInfo = {
  externalId: string;
  farmId: string;
  farmName: string;
  farmTimeZone: string;
  name: string;
  type: EntityType;
};

export const entityInfoApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEntityInfo: build.query<EntityInfo, string>({
      query: (entityId) => ({
        url: `/entities/${entityId}/info`,
      }),
      providesTags: ['EntityInfo'],
    }),
  }),
});

export const { useGetEntityInfoQuery } = entityInfoApi;
